import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiReportService } from '@providers/api/report/report.service';
import { UserProfile } from '@providers/api/user/user.data.interface';
import {
  BaseResponseBody,
  GETBaseResponseBody,
  GetUserProfileDetailsQueryParams
} from '@providers/api/user/user.request.interface';
import { UserAPIService } from '@providers/api/user/user.service';
import { QuestionnaireActiveSubmitPayload } from './active.interface';

/**
 * Questionnaire Active Service.
 *
 * @exports
 * @class QuestionnaireActiveService
 */
@Injectable()
export class QuestionnaireActiveService extends ApiReportService {
  private readonly userService = inject(UserAPIService);

  /**
   * Fetch user profile.
   *
   * @returns {Observable<GETBaseResponseBody<Array<UserProfile>>>}
   * @memberof QuestionnaireActiveService
   */
  fetchUserProfile(): Observable<GETBaseResponseBody<Array<UserProfile>>> {
    const params: GetUserProfileDetailsQueryParams = {
      limit: 1,
      withCount: false,
      include: [
        'allergy',
        'information',
        'medical',
        'medication',
        'user-lwb',
        'historical-last-state-update',
        'user-lifestyle'
      ]
    };
    return this.userService.get<GETBaseResponseBody<Array<UserProfile>>>(
      'user-profiles',
      params
    );
  }

  /**
   * Submit questionnaire.
   *
   * @param {QuestionnaireActiveSubmitPayload} body Payload.
   * @returns {Observable<BaseResponseBody<unknown>>}
   * @memberof QuestionnaireActiveService
   */
  submit(
    body: QuestionnaireActiveSubmitPayload
  ): Observable<BaseResponseBody<unknown>> {
    const endpoint = 'questionnaire/v2/submit-active';
    return this.post<BaseResponseBody<unknown>>(endpoint, body);
  }
}
